export default __webpack_public_path__ + "static/media/unigamer.009b8f38.svg";